import {
  GeographicalStatisticsObject,
  topPayorsMOSECRProps,
} from "src/pages/manufacturer/types";
import packageInfo from "../../package.json";
import axios from "axios";
import { COLOR_LIST } from "src/constants/cases";
import { UserType } from "src/types/users";
import { USER_TYPES } from "src/constants";

export const objectToQueryString = (obj: any) => {
  const keys = Object.keys(obj);
  const keyValuePairs = keys.map((key) => {
    return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
  });
  return keyValuePairs.join("&");
  // more code goes here
};
// export const wrapperFunction = (value: GeographicalStatisticsObject[]) => {
//   const dataArray: any = [];
//   if (value && value.length > 0) {
//     value.forEach((item) => {
//       const array: [string, number] = [
//         "us-" + item.state.toLocaleLowerCase(),
//         item.case_count,
//       ];
//       dataArray.push(array);
//     });
//   }
//   console.log("DataArray.....",dataArray)
//   return dataArray;
// };


// export const wrapperFunction = (value: GeographicalStatisticsObject[]) => {
//   const dataArray: Array<[string, number]> = [];

// /////////////       These Commented Code must be used for  future reference ////////////////
//   // Define a map for U.S. territories, if necessary
//   // const territoryCodes: { [key: string]: string } = {
//   //   "Puerto Rico": "us-pr",
//   //   Guam: "us-gu",
//   //   "American Samoa": "us-as",
//   //   "Northern Mariana Islands": "us-mp",
//   //   "U.S. Virgin Islands": "us-vi",
//   // };
//   //   ["pr-3614", 67], // puerto rico
//   //   ["gu-3605", 61], // Guam
//   //   ["mp-ti", 62], // tinian
//   //   ["mp-sa", 63], // saipan
//   //   ["mp-ro", 64] // rota
//   //   ['as-6515', 65],// eastern
//   //  ['as-6514', 66],// eastern
//   //  ['vi-3617', 68],// Saint Thomas
//   //  ['vi-6398', 69],// Saint Thomas
//   //  ['vi-6399', 70] // Saint Croix

// /////////////       The Above Commented Code must be used for  future reference ////////////////



//   if (value && value.length > 0) {
//     value.forEach((item) => {
//       // Check if it's a state or territory
//       const stateCode = item.state.toLocaleLowerCase();
//       const prefixedCode = "us-" + stateCode;
//       if (prefixedCode === "us-pr") {
//         dataArray.push(['pr-3614', item.case_count])
//       } else if (prefixedCode === "us-gu") {
//         dataArray.push(['gu-3605', item.case_count]);
//       } else if (prefixedCode === "us-as") {
//         dataArray.push(["as-6515", item.case_count]);
//         dataArray.push(["as-6514", item.case_count]);
//       } else if (prefixedCode === "us-mp") {
//         dataArray.push(["mp-ti", item.case_count]);
//         dataArray.push(["mp-sa", item.case_count]);
//         dataArray.push(["mp-ro", item.case_count]);
//       }else if (prefixedCode === "us-vi") {
//         dataArray.push(['vi-3617', item.case_count]);
//         dataArray.push(['vi-6398', item.case_count]);
//         dataArray.push(['vi-6399', item.case_count]);
//       }else {
//         dataArray.push([prefixedCode, item.case_count]);
//       }
//     });
//   }
//   return dataArray;
// };


export const wrapperFunction = (value: GeographicalStatisticsObject[]) => {
  const dataArray: Array<[string, number | null]> = [];

  // Map of specific codes for U.S. territories
  const territoryMap: { [key: string]: string[] } = {
    "us-pr": ['pr-3614'],
    "us-gu": ['gu-3605'],
    "us-as": ['as-6515', 'as-6514'],
    "us-mp": ['mp-ti', 'mp-sa', 'mp-ro'],
    "us-vi": ['vi-3617', 'vi-6398', 'vi-6399']
  };

  if (value && value.length > 0) {
    value.forEach((item) => {
      const stateCode = item.state.toLocaleLowerCase();
      const prefixedCode = "us-" + stateCode;

      // Check if the state is in the territoryMap
      if (territoryMap[prefixedCode]) {
        // Add all associated codes for the territory
        territoryMap[prefixedCode].forEach(code => {
          dataArray.push(item.case_count !== 0 ? [code, item.case_count] : [code, null]);
        });
      } else {
        // For regular states
        dataArray.push(item.case_count !== 0 ? [prefixedCode, item.case_count] : [prefixedCode, null]);
      }
    });
  }

  return dataArray;
};

export const wrapperFunctionPieChart = (
  pieChartData: topPayorsMOSECRProps[]
) => {
  return [{
    name: "Percentage",
    type: "pie",
    data: 
      pieChartData && pieChartData.length > 0 && pieChartData.map((item,key) => (item.name !== 'ALL TOP 10' && {
        name: `${(item.name || "")
          .toLowerCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())} <b>(${
          item.value
        })</b>`,
        title:`${(item.name || "")
          .toLowerCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())}`,
        value: item.value,
        y: item.percentage,
        color:COLOR_LIST[key]
      })),
  }];
};

export const updateApiVersion = async () => {
  const response = await axios(
    `${process.env.REACT_APP_BASE_URL}/update_api_version?APP_VERSION=${packageInfo.version}`,
    {
      method: "GET",
      headers: {
        ClientDb: process.env.REACT_APP_CLIENT_DB,
      },
    }
  );
  console.log(response, "     ");
};

export const emptyCacheAndCookies = () => {
  document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  if ("caches" in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    // Makes sure the page reloads. Changes are only visible after you refresh.
    setTimeout(() => window.location.reload(), 2000);
  }
};

export const formatStatistics = (
    values: (number | null)[],
    options?: { showPercentage?: boolean }
): string => {
  const [firstValue = 0, secondValue = 0] = values || [];
  const showPercentage = options?.showPercentage ?? true;

  const formatValue = (value: number | null) => {
    if (value === null || value === 0) return '0'; // Handle null and zero
    return Number.isInteger(value) ? value.toString() : value.toFixed(3);
  };

  const first = formatValue(firstValue);
  const second = formatValue(secondValue);

  if (showPercentage) {
    return `${first}% (${second}%)`;
  } else {
    return `${first} (${second})`;
  }
};

export const formatPhoneNumber = (phoneNumber: number | string): string => {
  const cleaned = (phoneNumber)?.toString()?.replace(/\D/g, '');
  if (cleaned && cleaned.length !== 10) {
    return phoneNumber?.toString(); // Return as-is if not valid
  }
  return cleaned?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};
export  const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  if (dateString.length>>0){
    return `${month}/${day}/${year}`;
  }
  else{
    return ``;
  }


};

export const routeToRelevantUser = (userData: UserType): string => {
  if (!userData.is_password_changed) {
    return "/users/createuser";
  } else {
    if (userData.ref_type === 'Manufacturer') {
      return "/statistics";
    } else if (userData.ref_type === "regional_manager") {
      return "/regions";
    } else if (userData.ref_type === "district_manager") {
      return "/districts";
    } else if (userData.ref_type === "rep") {
      return "/territories";
    } else if (userData.ref_type === "area_manager" || userData.ref_type === "area_supervisor") {
      return "/idp_territories"
    } else if (USER_TYPES.HCP.includes(userData.ref_type)) {
      return "/cases";
    } else {
      return ""
    }
  }
}

export function isMobile() {
  const ua = navigator.userAgent.toLowerCase();

  // Check via userAgentData (Chromium-based browsers only)
  if (Object.hasOwn(navigator, "userAgentData")) {
    (navigator as any).userAgentData.getHighEntropyValues(["model"])
      .then((data: any) => {
        if (/mobile|iphone|ipod|android/i.test(data.model || '')) {
          return true;
        }
      })
      .catch(() => false);
  }

  // Traditional UA check (covers older iPads or browsers that expose 'iPad')
  if (/mobile|iphone|ipod|android/.test(ua)) {
    return true;
  }

  return false;
}
